import { render, staticRenderFns } from "./listGmaeCom.vue?vue&type=template&id=2676b1a9&scoped=true&"
import script from "./listGmaeCom.vue?vue&type=script&lang=ts&"
export * from "./listGmaeCom.vue?vue&type=script&lang=ts&"
import style0 from "./listGmaeCom.vue?vue&type=style&index=0&id=2676b1a9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2676b1a9",
  null
  
)

export default component.exports